import { api as masterApi } from '@/api/api';
import { apis, inWindow } from '@/config';
export class DBFrequentInvokeInterceptor {
    constructor(interceptors) {
        this.triggerReportLimit = 20;
        this.tempInfoSet = new Set();
        this.exceptionInfoStore = new Map();
        this.expcetionStoreLimit = 20;
        this.systemApi = masterApi.getSystemApi();
        this.dataTrackerApi = masterApi.requireLogicalApi(apis.dataTrackerApiImp);
        if (!inWindow()) {
            return;
        }
        this.systemApi.intervalEvent({
            handler: ob => {
                if (ob.seq % 8 === 0) {
                    this.tempInfoSet.clear();
                }
                if (ob.seq % 800 === 0) {
                    this.exceptionInfoStore.clear();
                }
            },
            seq: 0,
            eventPeriod: 'mid',
        });
        const [interceptor] = interceptors;
        interceptor.use({
            namespace: apis.dbInterfaceApiImpl,
            type: 'normal',
            resolve: async (request) => {
                setTimeout(() => {
                    this.trackLog(request);
                }, 10);
                return request;
            },
        });
    }
    eject() { }
    trackLog(requestConfig) {
        const { args, namespace, apiname } = requestConfig;
        if (namespace !== apis.dbInterfaceApiImpl || Math.random() < 0.5) {
            return;
        }
        const md5 = this.systemApi.md5([apiname, JSON.stringify(args)].join('-'), true);
        if (this.exceptionInfoStore.has(md5)) {
            this.storeAndReport(md5, requestConfig);
        }
        else if (!this.exceptionInfoStore.has(md5) && this.tempInfoSet.has(md5)) {
            this.storeExceptionFromTemp(md5);
        }
        else {
            this.storeTempInfo(md5);
        }
    }
    storeTempInfo(md5) {
        while (this.tempInfoSet.size > DBFrequentInvokeInterceptor.tempInfoStoreLimit) {
            const { value: deleteId } = this.tempInfoSet.keys().next();
            this.tempInfoSet.delete(deleteId);
        }
        this.tempInfoSet.add(md5);
    }
    storeExceptionFromTemp(md5) {
        while (this.exceptionInfoStore.size > this.expcetionStoreLimit) {
            const { value: deleteMd5 } = this.exceptionInfoStore.keys().next();
            this.exceptionInfoStore.delete(deleteMd5);
        }
        this.exceptionInfoStore.set(md5, {
            count: 1,
            lasttimestamp: Date.now(),
        });
        this.tempInfoSet.delete(md5);
    }
    storeAndReport(md5, requestConfig) {
        const { lasttimestamp, count } = this.exceptionInfoStore.get(md5);
        const now = Date.now();
        this.exceptionInfoStore.delete(md5);
        if (now - lasttimestamp > 5000) {
            return;
        }
        const { apiname = '', args = [] } = requestConfig;
        if (count + 1 > this.triggerReportLimit) {
            this.dataTrackerApi.track('pc_db_frequent_excute', {
                apiname,
                argsinfo: JSON.stringify(args).slice(0, 200),
            });
            return;
        }
        this.exceptionInfoStore.set(md5, {
            count: count + 1,
            lasttimestamp: now,
        });
    }
}
DBFrequentInvokeInterceptor.tempInfoStoreLimit = 100;
